import { NotifyHelper } from "../../../helpers/toast";
import { eHoatDongHangNgayActionTypeDefine } from "../../action-types/diem-danh/IHoatDongHangNgayActionType";
import { generateActionForKey, generateActions } from "../generateActions";

export const hoatDongHangNgayActions = {
    ...generateActions(eHoatDongHangNgayActionTypeDefine, "HOAT_DONG_HANG_NGAY"),
    ...generateActionForKey(eHoatDongHangNgayActionTypeDefine, "HOAT_DONG_HANG_NGAY",
        "SUBMIT_DIEM_DANH_SUCCESS",
        () => { NotifyHelper.Success("Thành công") }
    ),
    ...generateActionForKey(eHoatDongHangNgayActionTypeDefine, "HOAT_DONG_HANG_NGAY",
        "SUBMIT_DIEM_DANH_ERROR",
        (m) => { NotifyHelper.Error(m) }
    ),
    ...generateActionForKey(eHoatDongHangNgayActionTypeDefine, "HOAT_DONG_HANG_NGAY",
        "SUBMIT_NHAN_XET_LOP_SUCCESS",
        () => { NotifyHelper.Success("Thành công") }
    ),
    ...generateActionForKey(eHoatDongHangNgayActionTypeDefine, "HOAT_DONG_HANG_NGAY",
        "SUBMIT_NHAN_XET_LOP_ERROR",
        (m) => { NotifyHelper.Error(m) }
    ),
    ...generateActionForKey(eHoatDongHangNgayActionTypeDefine, "HOAT_DONG_HANG_NGAY",
        "SUBMIT_NHAN_XET_HOC_SINH_SUCCESS",
        () => { NotifyHelper.Success("Thành công") }
    ),
    ...generateActionForKey(eHoatDongHangNgayActionTypeDefine, "HOAT_DONG_HANG_NGAY",
        "SUBMIT_NHAN_XET_HOC_SINH_ERROR",
        (m) => { NotifyHelper.Error(m) }
    ),

}
